<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :height="tableHeight"
      :loading="loading"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      row-key
      ref="XGrid"
      class="sortable-row-demo"
      :scroll-y="{ enabled: false }"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button
            size="sm"
            :disabled="isEdit"
            variant="outline-success"
            @click="openEditFormDialog({ type: 'add' })"
            ><b-icon-plus></b-icon-plus>
            添加
          </b-button>
        </slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.contactStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.v_contactStatus }}
        </el-tag>
      </template>
      <template v-slot:allow="{ row }">
        <el-tag
          size="mini"
          :type="row.allowLogin === 'Y' ? 'light' : 'warning'"
        >
          {{ row.v_allowLogin }}
        </el-tag>
      </template>
      <template v-slot:opt1>
        <span class="drag-btn">
          <i class="vxe-icon--menu"></i>
        </span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditFormDialog({
                  type: 'detail',
                  contactCode: row.contactCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditFormDialog({
                  type: 'edit',
                  contactCode: row.contactCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
            v-if="row.contactStatus === 'Y'"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.contactCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      v-el-dialog-drag
      show-close
      visible
      width="650px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :contactCode="editFormDialogOptions.contactCode"
        :carrierCode="code"
        @reload="getData"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">
          取消
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          v-if="!editFormDialogOptions.disabled"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import editForm from './edit-form'
import tableColumns from './contact-table-columns'
export default {
  components: { editForm },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
        zoom: true,
        custom: true,
      },
      showHelpTip1: false,
      tableColumns: tableColumns(),
      tableData: [],
      editFormDialogOptions: {
        visible: false,
        contactCode: '',
        carrierCode: '',
      },
    }
  },
  computed: {
    pageType() {
      return this.$route.params.pageType
    },
    isDisable() {
      return this.pageType === 'detail'
    },
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    if (this.sortable1) {
      this.sortable1.destroy()
    }
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },
    rowDrop() {
      this.$nextTick(() => {
        const xTable = this.$refs.XGrid
        this.sortable1 = Sortable.create(
          xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'),
          {
            handle: '.drag-btn',
            onEnd: ({ newIndex, oldIndex }) => {
              const currRow = this.tableData.splice(oldIndex, 1)[0]
              this.tableData.splice(newIndex, 0, currRow)
              this.updateNo(newIndex + 1, oldIndex + 1)
            },
          }
        )
      })
    },
    updateNo(newIndex, oldIndex) {
      if (newIndex === oldIndex) return
      this.$api
        .masterCarrierContactUpdateNoApi({
          newIndex: newIndex,
          oldIndex: oldIndex,
          carrierCode: this.code,
        })
        .then(() => {
          this.getData()
        })
    },
    getData() {
      if (!this.code) return
      this.$api
        .masterCarrierContactListApi({
          carrierCode: this.code,
        })
        .then((res) => {
          this.tableData = res.body.data

          this.rowDrop()
        })
    },
    del(contactCode) {
      this.$confirm('确认要删除该记录吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api.masterCarrierContactDelApi({ contactCode }).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.getData()
        })
      })
    },
    openEditFormDialog({ type = '', contactCode = '', carrierCode = '' }) {
      const types = {
        edit: '编辑联系人信息',
        add: '添加联系人信息',
        detail: '客户联系人信息详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        contactCode,
        carrierCode,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.sortable-row-demo .drag-btn {
  cursor: move;
  font-size: 12px;
}
.sortable-row-demo .vxe-body--row.sortable-ghost,
.sortable-row-demo .vxe-body--row.sortable-chosen {
  background-color: #dfecfb;
}
</style>
